import { localizationFormLocs } from './components/html-localize-form/html-localize-form.locs';
import { inliningLocalizationLocs } from './components/inlining-localization/inlining-localization.locs';
import { localizationModalLocs } from './components/localization-dialog/localization-dialog.locs';
import { sharedLocalizationLocs } from './shared.locs';

export const localizationModuleLocs = {
	...sharedLocalizationLocs,
	...localizationFormLocs,
	...localizationModalLocs,
	...inliningLocalizationLocs,
};
